import React, { useState } from 'react';
import {
  Box,
  TextField,
  Chip,
  Typography,
  Button,
  InputAdornment,
} from '@mui/material';
import { Add as AddIcon, Phone as PhoneIcon } from '@mui/icons-material';
import { useInput } from 'react-admin';

// Phone number validation function
const isValidPhoneNumber = (phone) => {
  // Basic phone number validation - adjust regex as needed for your requirements
  const phoneRegex = /^(\+98|0)?9\d{9}$/; // Iranian mobile numbers
  return phoneRegex.test(phone.replace(/\s/g, ''));
};

export default function PhoneNumberArrayInput({
  source, label, fullWidth, ...props
}) {
  const { field } = useInput({ source, ...props });
  const [currentPhone, setCurrentPhone] = useState('');
  const [error, setError] = useState('');

  const phoneNumbers = field.value || [];

  const addPhoneNumber = () => {
    const trimmedPhone = currentPhone.trim();

    if (!trimmedPhone) {
      setError('Phone number cannot be empty');
      return;
    }

    if (!isValidPhoneNumber(trimmedPhone)) {
      setError('Please enter a valid phone number');
      return;
    }

    if (phoneNumbers.includes(trimmedPhone)) {
      setError('Phone number already added');
      return;
    }

    field.onChange([...phoneNumbers, trimmedPhone]);
    setCurrentPhone('');
    setError('');
  };

  const removePhoneNumber = (phoneToRemove) => {
    field.onChange(phoneNumbers.filter((phone) => phone !== phoneToRemove));
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      addPhoneNumber();
    }
  };

  return (
    <Box sx={{ width: fullWidth ? '100%' : 'auto' }}>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
        {label}
      </Typography>

      <Box sx={{
        display: 'flex', gap: 1, mb: 2, alignItems: 'center',
      }}
      >
        <TextField
          value={currentPhone}
          onChange={(e) => {
            setCurrentPhone(e.target.value);
            setError('');
          }}
          onKeyPress={handleKeyPress}
          placeholder="Enter phone number"
          error={!!error}
          helperText={error}
          size="small"
          sx={{ flex: 1 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneIcon color="action" />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          onClick={addPhoneNumber}
          startIcon={<AddIcon />}
          size="small"
        >
          Add
        </Button>
      </Box>

      {phoneNumbers.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Phone Numbers (
            {phoneNumbers.length}
            ):
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {phoneNumbers.map((phone, index) => (
              <Chip
                key={index}
                label={phone}
                onDelete={() => removePhoneNumber(phone)}
                color="primary"
                variant="outlined"
                size="small"
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}
